var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 74,
    viewBox: "0 0 49 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5227 3.8862C47.9281 2.88572 45.6617 1.38499 38.518 0.57459C32.2268 -0.130754 24.5012 0.0118153 24.5012 0.0118153C24.5012 0.0118153 16.7731 -0.130754 10.4818 0.57459C3.3356 1.37498 1.07178 2.89072 0.477111 3.8862C-1.56467 7.27536 3.30753 22.6454 8.24608 25.2917C13.9503 28.3356 24.5012 27.988 24.5012 27.988C24.5012 27.988 35.0495 28.3356 40.7538 25.2917C45.6949 22.6554 50.5645 7.27536 48.5227 3.8862ZM18.8991 13.6585C17.9573 13.9661 17.3677 11.2423 14.619 11.2423C12.2505 11.2423 11.5231 13.4209 10.5073 13.4209C9.49156 13.4209 11.1122 9.46393 14.402 9.27384C17.6919 9.08374 19.8434 13.3508 18.8991 13.6585ZM38.4976 13.4209C37.4767 13.4209 36.7544 11.2423 34.386 11.2423C31.6296 11.2423 31.0477 13.9661 30.1059 13.6585C29.1641 13.3508 31.3156 9.08374 34.6029 9.27384C37.8902 9.46393 39.5134 13.4209 38.4976 13.4209Z",
    fill: "#3B1F8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 26C44 26 42.9937 28.954 42.0428 36.319C40.8102 45.912 40.619 70.2524 30.4206 73.3942C28.4961 74 24.4987 74 24.4987 74C24.4987 74 20.5039 74 18.5794 73.4067C8.38102 70.2649 8.18984 45.9245 6.95718 36.3315C6.0113 28.9665 5 26.0125 5 26.0125C5 26.0125 7.62885 28.3957 11.0853 29.3095C15.9053 30.5837 24.4987 30.7765 24.4987 30.7765C24.4987 30.7765 33.0947 30.5837 37.9147 29.3095C41.3837 28.3832 44 26 44 26Z",
    fill: "#3B1F8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79937 26C2.79937 26 4.20291 34.7645 4.76706 43.4442C5.07644 48.1975 6 55 6 55C6 55 1.63921 49.7331 1.36851 46.138C0.0218331 28.0723 2.79937 26 2.79937 26Z",
    fill: "#3B1F8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.202 26C46.202 26 44.7956 34.7645 44.2312 43.4442C43.9217 48.1975 43 55 43 55C43 55 47.3626 49.7331 47.6311 46.138C48.9783 28.0723 46.202 26 46.202 26Z",
    fill: "#3B1F8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L18.5317 21.2341C22.5892 19.2054 27.3782 19.2684 31.381 21.4032L32.5 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robotIcon.014f6227e1348f721ce697e0da82ec6e.svg";
export { ForwardRef as ReactComponent };